import { Section } from '~/shared/section/Section';
import { SectionTitle } from '~/shared/section/SectionTitle';
import { PatientAddresses } from '~/features/demographics/addresses/PatientAddresses';
import { useChart } from '~/features/admissions/charts/ChartContext';

export function PatientAddressesRoute() {
	const { stayId } = useChart();
	return (
		<Section header={<SectionTitle title="Addresses" />}>
			<PatientAddresses stayId={stayId} />
		</Section>
	);
}
